// import '../../style/index.scss';
import App from "./components";

export default App;
export { default as Booking } from './components/basket/booking';